{
  "schema_version": 1,
  "task_id": "L5-USER-DECISION-PROMPT-SURFACE-001",
  "status": "prompt-surface-ready",
  "generated_at": "2026-07-31T07:10:00+08:00",
  "source_activation_pack": "config/l5-user-decision-activation-pack.json",
  "authority_boundary": {
    "observational_only": true,
    "formal_gate_replacement": false,
    "mutation_authority": false,
    "approval_authority": false,
    "stores_user_decisions": false,
    "collects_secrets": false,
    "embeds_secret_values": false,
    "clipboard_write": false,
    "form_submit": false,
    "cloud_sync": false,
    "ecosystem_publish": false,
    "external_distribution": false,
    "external_write": false,
    "paid_action": false,
    "secret_storage": false,
    "deployment": false,
    "runtime_activation": false,
    "model_call": false,
    "task_completion_authority": false
  },
  "summary": {
    "prompt_surface_count": 3,
    "source_pack_count": 3,
    "readonly_textarea_required": true,
    "button_count_allowed": 0,
    "clipboard_write_allowed": false,
    "form_submit_allowed": false,
    "external_effect_count": 0,
    "secret_values_embedded_count": 0
  },
  "surface_contract": {
    "desktop_consumer": "apps/control-console/src/ui/AiosHome.tsx",
    "official_site_state_consumer": "apps/aios-official-site/src/shared/project-state.ts",
    "official_site_ui_consumer": "apps/aios-official-site/src/App.tsx",
    "must_render_readonly_textarea": true,
    "must_render_each_pack": true,
    "must_not_add_copy_button": true,
    "must_not_add_execute_button": true,
    "must_not_use_clipboard_api": true,
    "must_not_store_user_choices": true,
    "must_not_collect_secrets": true,
    "must_not_call_tauri_invoke": true
  },
  "prompts": [
    {
      "id": "PROMPT-REAL-CLOUD-SYNC",
      "source_pack_id": "ACTIVATE-REAL-CLOUD-SYNC",
      "source_decision_id": "L5-REAL-CLOUD-SYNC-USER-DECISION-001",
      "title_zh": "复制给 Codex：准备真实云同步 Task Spec",
      "title_en": "Copy to Codex: prepare the real cloud-sync Task Spec",
      "readonly": true,
      "stores_user_choice": false,
      "contains_secret_value": false
    },
    {
      "id": "PROMPT-ECOSYSTEM-PUBLISHING",
      "source_pack_id": "ACTIVATE-ECOSYSTEM-PUBLISHING",
      "source_decision_id": "L5-ECOSYSTEM-PUBLISHING-ACTIVATION-USER-DECISION-001",
      "title_zh": "复制给 Codex：准备生态发布 Task Spec",
      "title_en": "Copy to Codex: prepare the ecosystem publishing Task Spec",
      "readonly": true,
      "stores_user_choice": false,
      "contains_secret_value": false
    },
    {
      "id": "PROMPT-PRODUCTION-EXTERNAL-DISTRIBUTION",
      "source_pack_id": "ACTIVATE-PRODUCTION-EXTERNAL-DISTRIBUTION",
      "source_decision_id": "L5-EXTERNAL-DISTRIBUTION-USER-DECISION-001",
      "title_zh": "复制给 Codex：准备生产级外部分发 Task Spec",
      "title_en": "Copy to Codex: prepare the production distribution Task Spec",
      "readonly": true,
      "stores_user_choice": false,
      "contains_secret_value": false
    }
  ]
}
